import { IAvailabilityApiResponse } from './availability-response';
import { ITimeSlotApiResponse } from './timeslot';

/**
 * CamelCase response types for the scheduling-core service (Node.js backend).
 * Use these when consuming the core availability API; map to IAvailabilityApiResponse
 * before building ProviderAvailability.
 */

export interface ICoreSlotParticipant {
  providerId: string;
}

export interface ICoreAvailableSlot {
  start: string;
  end: string;
  participants: ICoreSlotParticipant[];
  sessionType: string;
  locationId?: number;
}

export interface ICoreSessionDurationType {
  participants: ICoreSlotParticipant[];
  tag: string | null;
  displayName: string | null;
  durationMinutes: number;
}

export interface ICoreAvailabilityApiResponse {
  availableSlots: ICoreAvailableSlot[];
  cached: boolean;
  cacheTimestamp: string;
  sessionDurationTypes?: ICoreSessionDurationType[];
}

/**
 * Maps a scheduling-core (camelCase) availability response to the snake_case
 * IAvailabilityApiResponse shape used by ProviderAvailability.
 */
export function mapCoreAvailabilityToApiResponse(
  res: ICoreAvailabilityApiResponse
): IAvailabilityApiResponse {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const available_slots: ITimeSlotApiResponse[] = res.availableSlots.map((slot) => ({
    start: new Date(slot.start),
    end: new Date(slot.end),
    participants: slot.participants.map((p) => ({ provider_id: p.providerId })),
    session_type: slot.sessionType,
    location_id: slot?.locationId ?? null,
  }));

  return {
    available_slots,
    cache: res.cached,
    cache_timestamp: new Date(res.cacheTimestamp)
  };
}
